// Session + auth API helpers. Session token lives in localStorage.

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const SESSION_KEY = "pa_session_token";
export const LICENSE_ID_KEY = "pa_license_id";
export const PHARMACY_NAME_KEY = "pa_pharmacy_name";

export function getSession() {
  const token = localStorage.getItem(SESSION_KEY);
  if (!token) return null;
  return {
    token,
    license_id: localStorage.getItem(LICENSE_ID_KEY) || "",
    pharmacy_name: localStorage.getItem(PHARMACY_NAME_KEY) || "",
  };
}

export function saveSession({ session_token, license_id, pharmacy_name }) {
  localStorage.setItem(SESSION_KEY, session_token);
  if (license_id) localStorage.setItem(LICENSE_ID_KEY, license_id);
  if (pharmacy_name) localStorage.setItem(PHARMACY_NAME_KEY, pharmacy_name);
}

export function clearSession() {
  // Only clear the session token — the license_id + pharmacy_name represent
  // the WebAuthn passkey pairing on THIS device and must persist so the user
  // can sign back in with Face ID. To fully unpair the device, call
  // clearPairing() instead.
  localStorage.removeItem(SESSION_KEY);
}

export function clearPairing() {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem(LICENSE_ID_KEY);
  localStorage.removeItem(PHARMACY_NAME_KEY);
}

async function api(path, opts = {}) {
  const res = await fetch(`${BACKEND}${path}`, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      ...(opts.headers || {}),
    },
  });
  const text = await res.text();
  let json;
  try { json = text ? JSON.parse(text) : {}; } catch { json = { raw: text }; }
  if (!res.ok) {
    const detail = json.detail || json.error || `HTTP_${res.status}`;
    throw new Error(String(detail));
  }
  return json;
}

// ---- End-user auth ----

export function verifyPin(pin) {
  return api("/api/auth/pin/verify", {
    method: "POST",
    body: JSON.stringify({ pin }),
  });
}

export function getRegisterOptions(registration_token) {
  return api("/api/auth/webauthn/register/options", {
    method: "POST",
    body: JSON.stringify({ registration_token }),
  });
}

export function finishRegister(registration_token, credential) {
  return api("/api/auth/webauthn/register/finish", {
    method: "POST",
    body: JSON.stringify({ registration_token, credential }),
  });
}

export function getAuthOptions(license_id) {
  return api("/api/auth/webauthn/auth/options", {
    method: "POST",
    body: JSON.stringify(license_id ? { license_id } : {}),
  });
}

export function finishAuth({ license_id, credential, challenge_token }) {
  return api("/api/auth/webauthn/auth/finish", {
    method: "POST",
    body: JSON.stringify({
      credential,
      ...(license_id ? { license_id } : {}),
      ...(challenge_token ? { challenge_token } : {}),
    }),
  });
}

export function meSession() {
  const s = getSession();
  if (!s) return Promise.reject(new Error("NO_SESSION"));
  return api("/api/auth/session/me", {
    headers: { Authorization: `Bearer ${s.token}` },
  });
}
